<template>
  <section class="section-pay w-full max-w-[1600px] mx-auto px-140 flex justify-between min-h-607 pt-120">
    <div class="section-pay-left text-left mr-100 w-1/2">
      <p class="text-1xl text-black mb-20">{{ $t('lang.speed1') }}</p>
      <p class=" text-black mb-10 font-bold" style="font-size: 45px;">{{ $t('lang.speed2') }}</p>
      <p class="text-[#FF7800] font-bold" style="font-size: 22px;">{{ $t('lang.speed3') }}</p>
      <p class="text-[#FF7800] font-bold" style="font-size: 22px;">{{ $t('lang.speed3_1') }}</p>

      <div class="mt-220">
        <p class="text-sm text-black  mb-10">{{ $t('lang.speed4') }}</p>
        <p class="text-sm text-black  mb-20">{{ $t('lang.speed5') }}</p>
        <el-button
            class="w-300 h-35 text-center"
            type="primary"
            style="background: #FF7800;border-radius: 5px 5px 5px 5px;border: 1px solid #FF7800;font-size:12px;padding: 0;"
          >{{ $t('lang.speed6') }}</el-button>
      </div>
    </div>
    <div class="section-pay-right w-1/2">
      <img src="../assets/home_27.png" alt="changjing" class="w-full h-524 object-scale-down" />
    </div>
  </section>
</template>

<script>
export default {
  name: "sectionPay",

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>